"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
function ControllerProviderFactory(controller) {
  function ControllerProvider(context) {
    context.controller = controller;

    return context;
  }

  return ControllerProvider;
}

exports.default = ControllerProviderFactory;
//# sourceMappingURL=Controller.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/lib/providers/Controller.js
// module id = 717
// module chunks = 0